<template>
  <div class="card" :class="{ 'card-inactive': isDisable }">
    <div class="card-body">
      <div class="card-title mb-1">Ссылки</div>
      <div v-if="links.length === 0" class="text-muted mb-3">
        Ссылки отсутствуют. Нажмите «Добавить», чтобы прикрепить ссылку.
      </div>

      <div
          v-for="(link, index) in links"
          :key="link.id"
          class="mb-3"
      >
        <div class="input-group input-group-flat">
          <input
              v-model="link.link"
              type="url"
              class="form-control"
              placeholder="https://example.com"
              @input="emitSuccess"
          />

          <span class="input-group-text px-2">
            <button
                type="button"
                class="btn-close text-danger"
                aria-label="Удалить"
                @click="removeLink(index)"
            ></button>
          </span>
        </div>
      </div>

      <button
          type="button"
          class="btn btn-outline-primary btn-sm d-flex align-items-center"
          @click="addLink"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-plus me-1" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M00h24v24H0z" fill="none"/>
          <path d="M12 5l0 14" />
          <path d="M5 12l14 0" />
        </svg>
        Добавить ссылку
      </button>
    </div>
  </div>
</template>

<script setup>
import {computed, ref, watch, toRaw, defineOptions} from 'vue'
import Helper from "@/services/Helper"
import Api from "./Api"

defineOptions({
  name: "WishlistWishLinks"
})

const props = defineProps({
  disable: {
    type: Boolean,
    required: true,
  },
  wishId: {
    type: Number,
    required: true,
  },
  initialLinks: {
    type: Array,
    required: true,
    default: () => []
  }
});

const emit = defineEmits(['onChange'])

const links = ref([]);

watch(
    () => props.initialLinks,
    (newLinks) => {
      const rawLinks = toRaw(newLinks);

      if (!Array.isArray(rawLinks)) {
        links.value = [];
        return;
      }

      const currentValues = links.value.map(l => l.link)
      const newValues = rawLinks.map(l => l.link)
      if (JSON.stringify(currentValues) !== JSON.stringify(newValues)) {
        links.value = rawLinks.map(link => ({
          ...link,
          id: Helper.generateId(),
          save: true,
        }));
      }
    },
    { immediate: true, deep: true }
);

const emitSuccess = (params) => {
  const cleanedLinks = links.value.map(({ ...rest }) => rest)
  const apiDelete = params?.api_delete ?? false
  emit('onChange', {
    success: true,
    api_delete: apiDelete,
    resp: {
      links: cleanedLinks
    },
  });
};

const emitFailure = (errorData = null) => {
  emit('onChange', {
    success: false,
    resp: errorData
  });
};

const addLink = () => {
  links.value.push({
    id: Helper.generateId(),
    link: '',
    shop_id: null,
    save: false,
  });

  emitSuccess()
};

const removeLink = async (index) => {
  if (links.value[index] === undefined) {
    return
  }

  let val = links.value[index];
  let isSave = val?.save ?? null

  if (isSave === false) {
    links.value.splice(index, 1)
    emitSuccess()
    return
  }

  let shopId = val?.shop_id ?? null
  if (shopId === null) {
    return
  }

  if (confirm("Вы действительно хотите удалить ссылку?")) {
    try {
      let resp = await Api.delete(props.wishId, shopId)

      let isSuccess = resp?.item ?? null

      if (isSuccess === true) {
        links.value.splice(index, 1)
        emitSuccess({
          api_delete: true,
        })
      } else {
        emitFailure({ message: "Ошибка от api при удалении картинки" })
      }
    } catch (err) {
      emitFailure({ message: "Ошибка при удалении картинки" })
    }
  }
}

const isDisable = computed(() => props.disable)
</script>

<style scoped>
.input-group-flat .form-control {
  border-right: 0;
}
.input-group-flat .input-group-text {
  background: transparent;
  border-left: 0;
}
.btn-close {
  background-size: 0.8rem;
  cursor: pointer;
}
.card-title {
  display: block;
  font-weight: 500;
  font-size: 14px;
  margin: 0;
}
</style>
